import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DateComponent} from '../../date/date.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [DateComponent]
})
export class FooterComponent implements OnInit {
  protected buildDate: Date = null;
  protected gitBranch = '';
  protected gitCommit = '';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get<{buildDate: string; gitBranch: string; gitCommit: string}>('/assets/build-info.json')
      .subscribe(info => {
        this.buildDate = info.buildDate ? new Date(Date.parse(info.buildDate)) : new Date();
        this.gitBranch = info.gitBranch || 'unknown';
        this.gitCommit = info.gitCommit || 'unknown';
      });
  }
}
